import { useEffect } from "react";

/**
 * Set per-route document.title, meta description, canonical URL and OG tags.
 * Preferred over pulling in react-helmet for a handful of routes.
 */
export default function useSEO({ title, description, path = "/", image }) {
  useEffect(() => {
    if (title) document.title = title;
    const canonical = `https://bigapizzeria.in${path}`;
    const setMeta = (attr, name, value) => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    if (image) setMeta("property", "og:image", image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, path, image]);
}
